var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React from 'react';
// dls
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
function withIconDefaults(Icon) {
    return function WrappedIcon(_a) {
        var { height = 20, width = 20, fillColor = tokens.colors.chalk100, className } = _a, props = __rest(_a, ["height", "width", "fillColor", "className"]);
        return (React.createElement("div", { style: { height: `${height}px`, width: `${width}px` }, className: className },
            React.createElement(Icon, Object.assign({ fillColor: fillColor }, props))));
    };
}
export default withIconDefaults;
